import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
  Row,
  Spinner,
  Tab,
  Tabs,
  Table
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrello } from '@fortawesome/free-brands-svg-icons';
import {
  faFileImport,
  faFileArchive,
  faFileInvoice,
  faDownload,
  faEye,
  faSyncAlt,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import SubtleBadge from 'components/common/SubtleBadge';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import KanbanContainer from '../process-kanban/KanbanImportacao';
import FilterDate from 'components/app/dashboard/FilterDate';
import api from 'helpers/api';
import {
  getIdEmpresa,
  getIdUsuario,
  getOperacaoLocal,
  setOperacaoLocal,
  getTiposOperacao
} from 'helpers/auth';
import * as XLSX from 'xlsx';
import { DownloadHS, Download, newDowload } from 'helpers/utils';
var jszip = require('jszip');
var saveAs = require('file-saver');

const Process = () => {
  const [data2, setData] = useState([]);
  const [dataKanbam, setDataKabam] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [view, setModoExibicao] = useState(1);
  const [searchTerm, setSearchTerm] = useState(''); // Estado para o termo de pesquisa
  const [filteredData, setFilteredData] = useState([]);
  const [dataFiles, setDataFiles] = useState([]);
  const [tipoOperacoes, setTipoOperacoes] = useState([]);
  const [selectAll, setSelectAll] = useState(true);
  const [modalShowArquivo, setModalShowArquivo] = React.useState(false);
  const [realizouConsulta, setRealizouConsulta] = React.useState(false);
  const [realizouConsultaDados, setRealizouConsultaDados] =
    React.useState(false);
  const [isDownloading, setisDownloading] = React.useState(false);
  const [existeArquivos, setExisteArquivos] = useState(false);
  const [preview, setPreview] = useState({
    fileData: null,
    fileName: '',
    fileType: ''
  });
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);
  const [isLoadingFile, setLoadingFile] = React.useState(false);
  const [selectedColumns, setSelectedColumns] = useState({
    processo: true,
    fatura: true,
    referencia: true,
    exportador: true,
    importador: true,
    follow: true,
    Modalidade: true,
    prevEmbarque: true,
    ConfEmbarque: true,
    PrevChegada: true,
    ConfChegada: true,
    status: true,
    RegistroDI: true,
    Presenca: true,
    des_canal: true,
    num_house: true,
    des_origem: true,
    des_destino: true
    // des_operacao: true
  });
  const [showModal, setShowModal] = useState(false);
  const [filterOperacao, setFilterOperacao] = useState('');
  const [filterPeriodo, setFilterPeriodo] = useState(
    ' AND p.dat_abertura >= CURDATE() - INTERVAL 180 day'
  );
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null
  });
  const handleColumnChange = column => {
    setSelectedColumns(prev => {
      const updatedColumns = {
        ...prev,
        [column]: !prev[column]
      };

      // Verifica se ainda há colunas selecionadas
      const anySelected = Object.values(updatedColumns).some(
        selected => selected
      );
      setSelectAll(!anySelected); // Atualiza o estado de "Selecionar Todos"

      return updatedColumns;
    });
  };

  const columns = [
    {
      accessor: 'processo',
      Header: 'Processo',
      headerProps: {
        className: 'fw-medium pe-1 text-900',
        style: { width: '20px' }
      },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { processoid, processo, modalidade, tipo_pro } =
          rowData.row.original;
        let sigla =
          tipo_pro === 'Agenciamento'
            ? 'A'
            : tipo_pro === 'Exportação'
            ? 'E'
            : 'I';
        return (
          <>
            <Link
              to={{
                // pathname: '/app/process/process-details/' + sigla + '&' + id
                pathname:
                  '/app/process/process-details/' + sigla + '&' + processoid
              }}
            >
              {/* <strong>{processoid}</strong> */}
              <strong>
                {processo}
                <FontAwesomeIcon
                  icon={classNames({
                    plane:
                      modalidade === 'Aereo' ||
                      modalidade === 'AIRFREIGHT' ||
                      modalidade === 'AÉREO',
                    truck:
                      modalidade === 'RODOVIÁRIO' ||
                      modalidade === 'Rodoviário' ||
                      modalidade === 'RODOVIARIO' ||
                      modalidade === 'COURIER',
                    ship:
                      modalidade === 'Marítimo' ||
                      modalidade === 'Maritimo' ||
                      modalidade === 'MARITIMA' ||
                      modalidade === 'BREAK BULK' ||
                      modalidade === 'MARÍTIMO (LCL)' ||
                      modalidade === 'MARÍTIMO (FCL)'
                  })}
                  transform="shrink-2"
                  className="ms-1"
                />
              </strong>{' '}
            </Link>{' '}
            <br />
          </>
        );
      }
    },

    // {
    //   accessor: 'nomeExportador',
    //   Header: 'Exportador',
    //   headerProps: {
    //     className: 'fw-medium pe-2 text-900',
    //     style: { width: '100px' }
    //   },
    //   cellProps: {
    //     className: 'py-2'
    //   }
    // },
    // {
    //   accessor: 'des_operacao',
    //   Header: 'Operação',
    //   headerProps: {
    //     className: 'fw-medium pe-2 text-900',
    //     style: {
    //       maxWidth: '100px', // Define a largura máxima do cabeçalho
    //       overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
    //       textOverflow: 'ellipsis', // Para adicionar reticências
    //       whiteSpace: 'nowrap' // Para evitar quebra de linha
    //     }
    //   },
    //   cellProps: {
    //     className: 'py-3',
    //     style: {
    //       maxWidth: '100px', // Define a largura máxima do cabeçalho
    //       overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
    //       textOverflow: 'ellipsis', // Para adicionar reticências
    //       whiteSpace: 'nowrap' // Para evitar quebra de linha
    //     }
    //   }
    // },
    // {
    //   accessor: 'fatura',
    //   Header: 'Fatura',
    //   headerProps: {
    //     className: 'fw-medium pe-2 text-900',
    //     style: {
    //       maxWidth: '100px', // Define a largura máxima do cabeçalho
    //       overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
    //       textOverflow: 'ellipsis', // Para adicionar reticências
    //       whiteSpace: 'nowrap' // Para evitar quebra de linha
    //     }
    //   },
    //   cellProps: {
    //     className: 'py-3',
    //     style: {
    //       maxWidth: '100px', // Define a largura máxima do cabeçalho
    //       overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
    //       textOverflow: 'ellipsis', // Para adicionar reticências
    //       whiteSpace: 'nowrap' // Para evitar quebra de linha
    //     }
    //   }
    // },
    {
      accessor: 'referencia',
      Header: 'Referência',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-3',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'follow',
      Header: 'Última Atualização',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '350px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '350px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'des_origem',
      Header: 'Origem',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '80px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'embarque',
      Header: 'Embarque',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '100px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'des_destino',
      Header: 'Destino',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '100px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'dataChegada',
      Header: 'Chegada',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '100px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      headerProps: {
        className: 'text-center text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'fs-0 py-2',
        style: {
          maxWidth: '150px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap', // Para evitar quebra de linha
          fontSize: '1.55rem'
        }
      },
      Cell: rowData => {
        const { status } = rowData.row.original;
        return (
          <SubtleBadge
            pill
            bg={classNames({
              success: status === 'Concluído' || status === 'Encerrado',
              danger:
                status === 'Em trânsito' ||
                status === 'Embarcado' ||
                status === 'Embarcado(s)' ||
                status === 'Desembaraçada' ||
                status === 'Aguarda Chegada' ||
                status === 'Aguarda Registro DI',
              warning:
                status === 'Aguardando Embarque' ||
                status === 'Aguarda Embarque' ||
                status === 'Ag. Embarque' ||
                status === 'Desembarcado' ||
                status === 'Aguardando Prontidão da Mercadoria',
              primary: status === 'Cancelado',
              secondary:
                status === 'Aguardando Booking' ||
                status === 'Desembaraço' ||
                status === 'Aguarda Desembaraço' ||
                status === 'Ag. Desembaraço' ||
                status === 'Aguarda Encerramento'
            })}
            className="d-flex flex-center"
          >
            <p className="mb-0">{status}</p>
            {/* <FontAwesomeIcon
icon={classNames({
check: status === 'Concluído',
truck: status === 'Em trânsito',
stream:
status === 'Aguardando Embarque' ||
status === 'Aguardando Prontidão da Mercadoria' ||
status === 'Desembaraço' ||
status === 'Desembarcado' ||
status === 'Embarcado'
})}
transform="shrink-2"
className="ms-1"
/> */}
          </SubtleBadge>
        );
      }
    },
    {
      Header: 'Opções',
      headerProps: {
        className: 'fw-medium pe-1 text-900',
        style: { width: '60px' }
      },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { processoid, processo, modalidade, tipo_pro } =
          rowData.row.original;
        let sigla =
          tipo_pro === 'Agenciamento'
            ? 'A'
            : tipo_pro === 'Exportação'
            ? 'E'
            : 'I';
        return (
          <>
            <Link
              to={{
                // pathname: '/app/process/process-details/' + sigla + '&' + id
                pathname:
                  '/app/process/process-details/' + sigla + '&' + processoid
              }}
            >
              {/* <strong>{processoid}</strong> */}
              <strong>
                {/* {processo} */}
                <FontAwesomeIcon
                  icon={faFileInvoice}
                  title="Detalhes"
                  style={{ cursor: 'pointer' }}
                  size="2x"
                />
              </strong>{' '}
            </Link>{' '}
            {sigla === 'I' || sigla === 'E' ? (
              <>
                <Link onClick={() => handleFiles(processoid)}>
                  {/* <strong>{processoid}</strong> */}
                  <strong>
                    {/* {processo} */}
                    <FontAwesomeIcon
                      icon={faFileArchive}
                      title="Arquivos"
                      style={{ cursor: 'pointer' }}
                      size="2x"
                    />
                  </strong>{' '}
                </Link>{' '}
              </>
            ) : (
              <></>
            )}
            <br />
          </>
        );
      }
    }
  ];

  const columnsExpo = [
    {
      accessor: 'processo',
      Header: 'Processo',
      headerProps: {
        className: 'fw-medium pe-1 text-900',
        style: { width: '20px' }
      },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { processoid, processo, modalidade, tipo_pro } =
          rowData.row.original;
        let sigla =
          tipo_pro === 'Agenciamento'
            ? 'A'
            : tipo_pro === 'Exportação'
            ? 'E'
            : 'I';
        return (
          <>
            <Link
              to={{
                // pathname: '/app/process/process-details/' + sigla + '&' + id
                pathname:
                  '/app/process/process-details/' + sigla + '&' + processoid
              }}
            >
              {/* <strong>{processoid}</strong> */}
              <strong>
                {processo}
                <FontAwesomeIcon
                  icon={classNames({
                    plane:
                      modalidade === 'Aereo' ||
                      modalidade === 'AIRFREIGHT' ||
                      modalidade === 'AÉREO',
                    truck:
                      modalidade === 'RODOVIÁRIO' ||
                      modalidade === 'Rodoviário' ||
                      modalidade === 'RODOVIARIO' ||
                      modalidade === 'COURIER',
                    ship:
                      modalidade === 'Marítimo' ||
                      modalidade === 'Maritimo' ||
                      modalidade === 'MARITIMA' ||
                      modalidade === 'MARÍTIMO (LCL)' ||
                      modalidade === 'MARÍTIMO (FCL)'
                  })}
                  transform="shrink-2"
                  className="ms-1"
                />
              </strong>{' '}
            </Link>{' '}
            <br />
          </>
        );
      }
    },
    {
      accessor: 'importador',
      Header: 'Importador',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: { width: '200px', maxWidth: '200px' }
      },
      cellProps: {
        className: 'py-3',
        style: {
          maxWidth: '200px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    // {
    //   accessor: 'des_operacao',
    //   Header: 'Operação',
    //   headerProps: {
    //     className: 'fw-medium pe-2 text-900',
    //     style: {
    //       maxWidth: '100px', // Define a largura máxima do cabeçalho
    //       overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
    //       textOverflow: 'ellipsis', // Para adicionar reticências
    //       whiteSpace: 'nowrap' // Para evitar quebra de linha
    //     }
    //   },
    //   cellProps: {
    //     className: 'py-3',
    //     style: {
    //       maxWidth: '100px', // Define a largura máxima do cabeçalho
    //       overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
    //       textOverflow: 'ellipsis', // Para adicionar reticências
    //       whiteSpace: 'nowrap' // Para evitar quebra de linha
    //     }
    //   }
    // },
    {
      accessor: 'referencia',
      Header: 'Referência',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-3',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'follow',
      Header: 'Última Atualização',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '600px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '600px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'des_origem',
      Header: 'Origem',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '80px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'embarque',
      Header: 'Embarque',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '80px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'des_destino',
      Header: 'Destino',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '100px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'datachegada',
      Header: 'Chegada',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '100px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },

    {
      accessor: 'status',
      Header: 'Status',
      headerProps: {
        className: 'text-center text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'fs-0 py-2',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      Cell: rowData => {
        const { status } = rowData.row.original;
        return (
          <SubtleBadge
            pill
            bg={classNames({
              success: status === 'Embarcado(s)',
              secondary: status === 'Ag. Desembaraço',
              primary: status === 'Cancelado',
              warning: status === 'Ag. Embarque'
            })}
            className="d-flex flex-center"
          >
            <p className="mb-0" style={{ fontSize: '0.65rem' }}>
              {status}
            </p>
            {/* <FontAwesomeIcon
icon={classNames({
check: status === 'Concluído',
truck: status === 'Em trânsito',
stream:
status === 'Aguardando Embarque' ||
status === 'Aguardando Prontidão da Mercadoria' ||
status === 'Desembaraço' ||
status === 'Desembarcado' ||
status === 'Embarcado'
})}
transform="shrink-2"
className="ms-1"
/> */}
          </SubtleBadge>
        );
      }
    },
    {
      Header: 'Opções',
      headerProps: {
        className: 'fw-medium pe-1 text-900',
        style: { width: '60px' }
      },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { processoid, processo, modalidade, tipo_pro } =
          rowData.row.original;
        let sigla =
          tipo_pro === 'Agenciamento'
            ? 'A'
            : tipo_pro === 'Exportação'
            ? 'E'
            : 'I';
        return (
          <>
            <Link
              to={{
                // pathname: '/app/process/process-details/' + sigla + '&' + id
                pathname:
                  '/app/process/process-details/' + sigla + '&' + processoid
              }}
            >
              {/* <strong>{processoid}</strong> */}
              <strong>
                {/* {processo} */}
                <FontAwesomeIcon
                  icon={faFileInvoice}
                  title="Detalhes"
                  style={{ cursor: 'pointer' }}
                  size="2x"
                />
              </strong>{' '}
            </Link>{' '}
            <Link onClick={() => handleFiles(processoid)}>
              {/* <strong>{processoid}</strong> */}
              <strong>
                {/* {processo} */}
                <FontAwesomeIcon
                  icon={faFileArchive}
                  title="Arquivos"
                  style={{ cursor: 'pointer' }}
                  size="2x"
                />
              </strong>{' '}
            </Link>{' '}
            <br />
          </>
        );
      }
    }
  ];

  const columnsAgenciamento = [
    {
      accessor: 'processo',
      Header: 'Processo',
      headerProps: {
        className: 'fw-medium pe-1 text-900',
        style: { width: '20px' }
      },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { processoid, processo, modalidade, tipo_pro } =
          rowData.row.original;
        let sigla =
          tipo_pro === 'Agenciamento'
            ? 'A'
            : tipo_pro === 'Exportação'
            ? 'E'
            : 'I';
        return (
          <>
            <Link
              to={{
                // pathname: '/app/process/process-details/' + sigla + '&' + id
                pathname:
                  '/app/process/process-details/' + sigla + '&' + processoid
              }}
            >
              {/* <strong>{processoid}</strong> */}
              <strong>
                {processo}
                <FontAwesomeIcon
                  icon={classNames({
                    plane:
                      modalidade === 'Aereo' ||
                      modalidade === 'AIRFREIGHT' ||
                      modalidade === 'AÉREO',
                    truck:
                      modalidade === 'RODOVIÁRIO' ||
                      modalidade === 'Rodoviário' ||
                      modalidade === 'RODOVIARIO' ||
                      modalidade === 'COURIER',
                    ship:
                      modalidade === 'Marítimo' ||
                      modalidade === 'Maritimo' ||
                      modalidade === 'MARITIMA' ||
                      modalidade === 'MARÍTIMO (LCL)' ||
                      modalidade === 'MARÍTIMO (FCL)'
                  })}
                  transform="shrink-2"
                  className="ms-1"
                />
              </strong>{' '}
            </Link>{' '}
            <br />
          </>
        );
      }
    },
    // {
    //   accessor: 'nomeExportador',
    //   Header: 'Exportador',
    //   headerProps: {
    //     className: 'fw-medium pe-2 text-900',
    //     style: { width: '200px', maxWidth: '200px' }
    //   },
    //   cellProps: {
    //     className: 'py-3',
    //     style: {
    //       maxWidth: '200px', // Define a largura máxima do cabeçalho
    //       overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
    //       textOverflow: 'ellipsis', // Para adicionar reticências
    //       whiteSpace: 'nowrap' // Para evitar quebra de linha
    //     }
    //   }
    // },
    {
      accessor: 'referencia',
      Header: 'Referência',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-3',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'follow',
      Header: 'Última Atualização',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '600px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '600px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'des_origem',
      Header: 'Origem',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '80px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'embarque',
      Header: 'Embarque',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '80px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'des_destino',
      Header: 'Destino',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '100px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },
    {
      accessor: 'datachegada',
      Header: 'Chegada',
      headerProps: {
        className: 'fw-medium pe-2 text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'py-2',
        style: {
          maxWidth: '100px', // Define a largura máxima da célula
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      }
    },

    {
      accessor: 'status',
      Header: 'Status',
      headerProps: {
        className: 'text-center text-900',
        style: {
          maxWidth: '100px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap' // Para evitar quebra de linha
        }
      },
      cellProps: {
        className: 'fs-0 py-2',
        style: {
          maxWidth: '150px', // Define a largura máxima do cabeçalho
          overflow: 'hidden', // Para esconder o conteúdo que ultrapassa
          textOverflow: 'ellipsis', // Para adicionar reticências
          whiteSpace: 'nowrap', // Para evitar quebra de linha
          fontSize: '1.55rem'
        }
      },
      Cell: rowData => {
        const { status } = rowData.row.original;
        return (
          <SubtleBadge
            pill
            bg={classNames({
              success: status === 'Concluído' || status === 'Encerrado',
              danger:
                status === 'Em trânsito' ||
                status === 'Embarcado' ||
                status === 'Embarcado(s)' ||
                status === 'Desembaraçada' ||
                status === 'Aguarda Chegada' ||
                status === 'Aguarda Registro DI',
              warning:
                status === 'Aguardando Embarque' ||
                status === 'Aguarda Embarque' ||
                status === 'Ag. Embarque' ||
                status === 'Desembarcado' ||
                status === 'Aguardando Prontidão da Mercadoria',
              primary: status === 'Cancelado',
              secondary:
                status === 'Aguardando Booking' ||
                status === 'Desembaraço' ||
                status === 'Aguarda Desembaraço' ||
                status === 'Ag. Desembaraço' ||
                status === 'Aguarda Encerramento'
            })}
            className="d-flex flex-center"
          >
            <p className="mb-0">{status}</p>
          </SubtleBadge>
        );
      }
    },
    {
      Header: 'Opções',
      headerProps: {
        className: 'fw-medium pe-1 text-900',
        style: { width: '60px' }
      },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { processoid, processo, modalidade, tipo_pro } =
          rowData.row.original;
        let sigla =
          tipo_pro === 'Agenciamento'
            ? 'A'
            : tipo_pro === 'Exportação'
            ? 'E'
            : 'I';
        return (
          <>
            <Link
              to={{
                // pathname: '/app/process/process-details/' + sigla + '&' + id
                pathname:
                  '/app/process/process-details/' + sigla + '&' + processoid
              }}
            >
              {/* <strong>{processoid}</strong> */}
              <strong>
                {/* {processo} */}
                <FontAwesomeIcon
                  icon={faFileInvoice}
                  title="Detalhes"
                  style={{ cursor: 'pointer' }}
                  size="2x"
                />
              </strong>{' '}
            </Link>{' '}
            {sigla === 'I' || sigla === 'E' ? (
              <>
                <Link onClick={() => handleFiles(processoid)}>
                  {/* <strong>{processoid}</strong> */}
                  <strong>
                    {/* {processo} */}
                    <FontAwesomeIcon
                      icon={faFileArchive}
                      title="Arquivos"
                      style={{ cursor: 'pointer' }}
                      size="2x"
                    />
                  </strong>{' '}
                </Link>{' '}
              </>
            ) : (
              <></>
            )}
            <br />
          </>
        );
      }
    }
  ];
  const [columnsToShow, setColumnsToShow] = useState(columns);

  useEffect(() => {
    if (getIdUsuario() === null) {
      window.location.href = '/';
    }
    setFilterOperacao(getOperacaoLocal());
    const today = new Date();
    const pastDate = new Date(today);
    pastDate.setDate(today.getDate() - 180);

    setDateRange({
      startDate: today,
      endDate: today
    });
    const getProcess = async () => {
      const recuperarArray = () => {
        const array = JSON.parse(localStorage.getItem('OPERACOES'));
        return array ? array : []; // Retorna um array vazio se não houver nada
      };
      const arrayRecuperado = recuperarArray();
      setTipoOperacoes(arrayRecuperado);
      setIsLoading(true);
      setRealizouConsultaDados(true);
      const result = await api.post('/api/processes/', {
        companyId: getIdEmpresa(),
        operacao: getOperacaoLocal()
      });      
      const data = result.data.data;

      setData(data);
      setIsLoading(false);
      setRealizouConsultaDados(false);
    };
    if (getIdEmpresa() > 0) {
      getProcess();
    }
    refreshProcesss();
  }, []);

  const handleClick = selectedView => {
    // Verifica se a nova visualização é diferente da atual
    if (selectedView !== view) {
      setModoExibicao(selectedView); // Atualiza a visualização
    }
  };

  // Atualiza filteredData sempre que data2 ou searchTerm mudar
  useEffect(() => {
    // const today = new Date();
    // const pastDate = new Date(today);
    // pastDate.setDate(today.getDate() - 180);

    // setDateRange({
    // startDate: pastDate,
    // endDate: today,
    // });
    const newFilteredData = data2.filter(item => {
      const term = searchTerm.toLowerCase();
      return (
        (item.status &&
          typeof item.status === 'string' &&
          item.status.toLowerCase().includes(term)) ||
        (item.processo &&
          typeof item.processo === 'string' &&
          item.processo.toLowerCase().includes(term)) ||
        (item.exportador &&
          typeof item.exportador === 'string' &&
          item.exportador.toLowerCase().includes(term)) ||
        (item.referencia &&
          typeof item.referencia === 'string' &&
          item.referencia.toLowerCase().includes(term)) ||
        (item.modalidade &&
          typeof item.modalidade === 'string' &&
          item.modalidade.toLowerCase().includes(term))
      );
    });
    // setFilteredData(newFilteredData); // Atualiza o estado com os dados filtrados
  }, [data2, searchTerm]); // Dependências

  // Mapeamento dos rótulos personalizados
  const columnLabels = {
    processo: 'Número do Processo',
    fatura: 'Fatura',
    referencia: 'Referência',
    exportador: 'Nome do Exportador',
    importador: 'Nome do Importador',
    follow: 'Último Follow',
    Modalidade: 'Modalidade',
    prevEmbarque: 'Prev. Embarque',
    ConfEmbarque: 'Conf. Embarque',
    PrevChegada: 'Prev. Chegada',
    ConfChegada: 'Conf. Chegada',
    status: 'Status',
    RegistroDI: 'Registro DI',
    Presenca: 'Presença',
    des_canal: 'Canal',
    num_house: 'House',
    des_origem: 'Origem',
    des_destino: 'Destino'
    // des_operacao: 'Operação'
  };

  // Função para exportar os dados filtrados para Excel
  const exportToExcel = dados => {
    const columnsToExport = Object.keys(selectedColumns).filter(
      col => selectedColumns[col]
    );

    const exportData = dados.map(item => {
      return columnsToExport.reduce((obj, key) => {
        obj[columnLabels[key]] = item[key];
        return obj;
      }, {});
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

    // Gera um arquivo Excel
    XLSX.writeFile(workbook, 'processos.xlsx');
  };

  const handleSelectAllChange = event => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setSelectedColumns(prev => {
      const updatedColumns = {};
      Object.keys(prev).forEach(key => {
        updatedColumns[key] = isChecked; // Define todas as colunas para o estado do checkbox
      });
      return updatedColumns;
    });
  };

  const parseDateString = dateString => {
    const [day, month, year] = dateString.split('/'); // Exemplo: "31/12/2023"
    return new Date(`${year}-${month}-${day}`); // Converte para YYYY-MM-DD
  };

  const FileDownloadFilesBlob = async (dataFile, qual) => {
    setLoadingFile(true);
    var zip = new jszip();
    dataFile.forEach(async element => {
      if (qual === 'Todos') {
        if (element['Folder'] === 'Processo' || element['Folder'] === null) {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('processo');
          img.file(element['FileName'], blob);
        }
        if (element['Folder'] === 'Financeiro') {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('financeiro');
          img.file(element['FileName'], blob);
        }
      } else if (qual === 'Processo') {
        if (element['Folder'] === 'Processo' || element['Folder'] === null) {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('processo');
          img.file(element['FileName'], blob);
        }
      } else if (qual === 'Financeiro') {
        if (element['Folder'] === 'Financeiro') {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('financeiro');
          img.file(element['FileName'], blob);
        }
      }
    });
    setLoadingFile(false);
    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, 'arquivos.zip');
    });
  };

  const getAll = async id => {
    const result = await api.get('/api/empresas/file/' + id);
    var blob = newDowload(
      result.data.result[0].File.data,
      'application/' +
        result.data.result[0].FileName.substring(
          result.data.result[0].FileName.indexOf('.') + 1
        ),
      result.data.result[0].FileName
    );
    return blob;
  };

  const getUrlFile = async id => {
    if (getOperacaoLocal() !== 'AGENCIAMENTO') {
      const result = await api.get(`/api/empresas/file/${id}`);
      Download(
        result.data.result[0].File.data,
        'application/' +
          result.data.result[0].FileName.substring(
            result.data.result[0].FileName.indexOf('.') + 1
          ),
        result.data.result[0].FileName
      );
    } else {
      const result = await api.get(`/api/hs/arquivoURL/${id}`);
      DownloadHS(result.data.result, 'Teste.pdf');
    }

    // } else if (operacao[0] === 'T') {
    // setisDownloading(true);
    // const result = await api.get(`/api/empresas/arquivoURL/${id}`);

    // let a = document.createElement('a');
    // a.href = result.data.result.url;
    // a.download = result.data.result.filename;
    // setisDownloading(false);
    // a.click();
  };

  const getShowFIle = async id => {
    try {
      const result = await api.get(`/api/empresas/file/${id}`);
      // const fileBlob = new Blob([result.data.result[0].File.data], {
      //   type: 'application/' + result.data.result[0].FileName.split('.').pop(),
      // });

      const fileData = URL.createObjectURL(
        newDowload(
          result.data.result[0].File.data,
          'application/' +
            result.data.result[0].FileName.substring(
              result.data.result[0].FileName.indexOf('.') + 1
            ),
          result.data.result[0].FileName
        )
      );
      const fileType = result.data.result[0].FileName.split('.').pop();

      setPreview({
        fileData,
        fileName: result.data.result[0].FileName,
        fileType
      });
      setIsPreviewVisible(true);
    } catch (error) {}
    setIsPreviewVisible(true);
    openInNewTab();
  };

  const openInNewTab = () => {
    if (preview.fileData) {
      window.open(preview.fileData, '_blank');
    }
  };

  const defineOperation = async () => {
    if (getTiposOperacao().length > 0) {
      const data = getTiposOperacao();
      for (let index = 0; index < data.length; index++) {
        if (data[index].operacao === 'FRETE') {
          setExisteFrete(true);
          setExisteEmbarque(true);
        }
        if (data[index].operacao === 'IMPORTAÇÃO') {
          setOperacaoLocal('IMPORTAÇÃO');
          setFilterOperacao('IMPORTAÇÃO');
          setNameOperacao('IMPORTAÇÃO');
          setExisteImportacao(true);
          setPossuiImpo(1);
        }
        if (data[index].operacao === 'EXPORTAÇÃO') {
          setExisteExportacao(true);
          setOperacaoLocal('EXPORTAÇÃO');
          setFilterOperacao('EXPORTAÇÃO');
          setNameOperacao('EXPORTAÇÃO');
          setPossuiExpo(1);
        }
      }
      if (nameOperacao !== '') {
        setSelectedId(nameOperacao);
      }
    }
  };

  const handleOperationChange = event => {
    setFilterOperacao(event.target.value);
    setOperacaoLocal(event.target.value);
  };

  const handleDateChange = date => {
    //Pega Data do Período
    setFilterPeriodo(` AND p.dat_abertura ${date}`);
  };

  const refreshProcesss = async date => {
    // setFilterPeriodo(` AND p.dat_abertura ${date}`);
    atualizaDados();
  };

  const atualizaDados = async () => {
    setRealizouConsultaDados(true);
    // const result = await api.get(
    // // '/api/empresas/allprocess/' + getIdEmpresa()
    // '/api/processes/' + getIdEmpresa()
    // );
    const result = await api.post(
      // '/api/empresas/allprocess/' + getIdEmpresa()
      '/api/processes/',
      {
        companyId: getIdEmpresa(),
        operacao: getOperacaoLocal(),
        filter: filterPeriodo
      }
    );

    const data = result.data.data;

    setData(data);
    // Atualiza as colunas a serem exibidas com base na operação selecionada
    if (filterOperacao === 'EXPORTAÇÃO') {
      setColumnsToShow(columnsExpo);
    } else if (filterOperacao === 'IMPORTAÇÃO') {
      setColumnsToShow(columns);
    } else {
      setColumnsToShow(columnsAgenciamento);
    }

    setRealizouConsultaDados(false);
  };

  const handleFiles = async value => {
    setDataFiles([]);
    setRealizouConsulta(false);
    setModalShowArquivo(true);
    try {
      if (getOperacaoLocal() !== 'AGENCIAMENTO') {
        const result = await api.get(`/api/empresas/arquivos/${value}`);
        if (result.data.result.length > 0) {
          setExisteArquivos(true);
          setDataFiles(result.data.result);
        }
      } else {
        const result = await api.get(`/api/hs/arquivos/${value}`);
        setDataFiles(result.data.result.recordset);
        if (result.data.result.recordset.length > 0) {
          setExisteArquivos(true);
          setDataFiles(result.data.result.recordset);
        }
      }
    } catch (err) {
    } finally {
      setRealizouConsulta(true);
    }
  };

  return (
    <>
      {isLoading ? (
        <>
          <Flex justifyContent="center">
            <div className="p-2">
              <Spinner />
              <span> Aguarde carregando ...</span>
            </div>
          </Flex>
        </>
      ) : (
        <AdvanceTableWrapper
          columns={columnsToShow}
          data={data2}
          sortable
          pagination
          perPage={20}
          tableProps={{
            size: 'xs',
            striped: true,
            className: 'fs--1 mb-0 overflow-hidden'
          }}
        >
          <Card
            className="mb-3"
            style={{ height: 'auto', display: 'flex', flexDirection: 'column' }}
          >
            <Card.Header>
              <Row className="">
                <Col xs={3} sm="auto" lg={3}>
                  <Form.Label>Pesquisar</Form.Label>
                  <AdvanceTableSearchBox
                    table
                    onChange={e => setSearchTerm(e.target.value)}
                    globalFilter={filteredData}
                    setGlobalFilter={filteredData}
                  />
                </Col>
                <Col md={2} xxl={2}>
                  <Form.Group>
                    <Form.Label>Operação</Form.Label>
                    <Form.Select
                      size="sm"
                      value={filterOperacao}
                      onChange={handleOperationChange}
                    >
                      <option value="">Selecione:</option>
                      {tipoOperacoes.map(row => {
                        return (
                          <>
                            <option value={row.operacao}>{row.operacao}</option>
                          </>
                        );
                      })}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={2} xxl={2} sm="auto">
                  <Form.Group controlId="releaseDate">
                    <Form.Label>
                      <>
                        <span>Período</span>
                        <span
                          style={{ marginLeft: '0.5rem', cursor: 'pointer' }}
                          data-toggle="tooltip"
                          title="Filtro baseado na Data de Abertura"
                        >
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </span>
                      </>
                    </Form.Label>
                    <FilterDate
                      onDateChange={handleDateChange}
                      startDate={dateRange.startDate}
                      endDate={dateRange.endDate}
                    />
                  </Form.Group>
                </Col>
                <Col md={3} xxl={3}>
                  <IconButton
                    variant="primary"
                    size="sm"
                    alt="Atualizar"
                    aria-label="Atualizar"
                    onClick={() => refreshProcesss()}
                    className="mt-4"
                  >
                    <FontAwesomeIcon icon={faSyncAlt} /> Atualizar
                  </IconButton>
                </Col>
                <Col xs="auto" className="d-flex align-items-right">
                  <FontAwesomeIcon
                    className="p-2"
                    icon={faFileImport}
                    title="Exportar xlsx"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowModal(true)}
                  />
                  {filterOperacao === 'EXPORTAÇÃO' ||
                  filterOperacao === 'IMPORTAÇÃO' ? (
                    <>
                      <FontAwesomeIcon
                        className="p-2"
                        icon={classNames({
                          list: true
                        })}
                        title="Modo Lista"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleClick(1)}
                      />
                    </>
                  ) : (
                    <></>
                  )}

                  {filterOperacao === 'EXPORTAÇÃO' ||
                  filterOperacao === 'IMPORTAÇÃO' ? (
                    <>
                      <FontAwesomeIcon
                        className="p-2"
                        icon={faTrello}
                        title="Modo Kanban"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleClick(2)}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Card.Header>
            {!realizouConsultaDados ? (
              <>
                {view === 1 ? (
                  <>
                    <Card.Body className="p-0" style={{ flex: 1 }}>
                      <AdvanceTable
                        table
                        headerClassName="bg-200 text-nowrap align-middle"
                        rowClassName="align-middle white-space-nowrap"
                        tableProps={{
                          size: 'sm',
                          striped: true,
                          className: 'fs--1 mb-0 overflow-hidden'
                        }}
                      />
                    </Card.Body>
                    <Card.Footer>
                      <div className="mt-3">
                        <AdvanceTableFooter
                          rowCount={
                            filteredData.length > 0
                              ? filteredData.length
                              : data2.length
                          }
                          table
                          canPreviousPage
                          rowInfo
                          navButtons
                          rowsPerPageSelection
                        />
                      </div>
                    </Card.Footer>
                  </>
                ) : (
                  <>
                    <Card.Body style={{ flex: 1 }}>
                      <KanbanContainer
                        operacao={getOperacaoLocal()}
                        filterPeriodo={filterPeriodo}
                      />
                    </Card.Body>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
          </Card>
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Selecionar Colunas para Exportar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col xs={12}>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={selectAll}
                      onChange={handleSelectAllChange}
                      id="selectAll"
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="selectAll"
                    >
                      Selecionar Todas
                    </label>
                  </div>
                </Col>
                {Object.keys(selectedColumns).map(column => (
                  <Col xs={6} key={column}>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selectedColumns[column]}
                        onChange={() => handleColumnChange(column)}
                        id={column}
                      />
                      <label className="form-check-label ms-2" htmlFor={column}>
                        {columnLabels[column]}
                      </label>
                    </div>
                  </Col>
                ))}
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Cancelar
              </Button>
              <Button
                variant="primary"
                onClick={() =>
                  exportToExcel(filteredData.length > 0 ? filteredData : data2)
                }
              >
                Confirmar
              </Button>
            </Modal.Footer>
          </Modal>
          {/*Modal Arquivo*/}
          {filterOperacao === 'AGENCIAMENTO' ? (
            <>
              <Modal
                show={modalShowArquivo}
                onHide={() => setModalShowArquivo(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header>
                  <Modal.Title
                    id="contained-modal-title-vcenter"
                    style={{ fontSize: '0.875rem' }}
                  >
                    Arquivos
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Tabs
                    defaultActiveKey="processo"
                    id="uncontrolled-tab-example"
                  >
                    <Tab
                      eventKey="processo"
                      title="Processo"
                      className="p-3"
                      style={{ fontSize: '0.875rem' }}
                    >
                      <Table size="sm">
                        <thead>
                          <tr>
                            <th style={{ fontSize: '0.875rem' }}>
                              Data
                              {isDownloading ? (
                                <>
                                  <Spinner
                                    size="1rem"
                                    style={{ color: 'black' }}
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                            </th>
                            <th style={{ fontSize: '0.875rem' }}>Descricao</th>
                            <th
                              style={{
                                alignItems: 'center',
                                textAlign: 'center',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                fontSize: '0.875rem'
                              }}
                            >
                              Download
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataFiles
                            .sort(
                              (a, b) =>
                                parseDateString(b.DataArquivo) -
                                parseDateString(a.DataArquivo)
                            )
                            .map(row => {
                              return (
                                <>
                                  <tr key={row.IdArquivo}>
                                    <td style={{ fontSize: '0.75rem' }}>
                                      {row.DataArquivo}
                                    </td>
                                    <td style={{ fontSize: '0.75rem' }}>
                                      {row.Descricao}
                                    </td>
                                    <td
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        fontSize: '0.75rem'
                                      }}
                                    >
                                      {' '}
                                      <IconButton
                                        size="sm"
                                        alt="Baixar Arquivo"
                                        aria-label="Baixar Arquivo"
                                        onClick={() =>
                                          getUrlFile(row.IdArquivo)
                                        }
                                        style={{
                                          marginLeft: 'auto',
                                          marginRight: 'auto'
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faDownload} />
                                      </IconButton>
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                        </tbody>
                      </Table>
                    </Tab>
                  </Tabs>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => setModalShowArquivo(false)} size="sm">
                    Fechar
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          ) : (
            <>
              <Modal
                show={modalShowArquivo}
                onHide={() => setModalShowArquivo(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header>
                  <Modal.Title
                    id="contained-modal-title-vcenter"
                    style={{ fontSize: '0.875rem' }}
                  >
                    Arquivos
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {realizouConsulta ? (
                    <>
                      <>
                        <IconButton
                          size="sm"
                          alt="Baixar Arquivo"
                          aria-label="Baixar Arquivo"
                          onClick={() =>
                            FileDownloadFilesBlob(dataFiles, 'Todos')
                          }
                          style={{
                            marginLeft: 'auto',
                            marginRight: 'auto'
                          }}
                        >
                          Baixar Todos(Processo / Financeiro)
                          <FontAwesomeIcon icon={faDownload} />
                        </IconButton>
                        {/* <button
onClick={(event) => FileDownloadFilesBlob(dataFiles, "Todos")}
style={{ cursor: "pointer" }}
>
<div style={{ height: "20px" }}>
<span>Baixar Todos(Processo / Financeiro)</span>&nbsp;
<FontAwesomeIcon icon={faDownload} />
</div>
</button> */}
                      </>
                      <Tabs
                        defaultActiveKey="processo"
                        id="uncontrolled-tab-example"
                      >
                        <Tab
                          eventKey="processo"
                          title="Processo"
                          className="p-3"
                          style={{ fontSize: '0.875rem' }}
                        >
                          <Table size="sm">
                            <thead>
                              <tr>
                                <th style={{ fontSize: '0.875rem' }}>
                                  Data
                                  {isDownloading ? (
                                    <>
                                      <Spinner
                                        size="1rem"
                                        style={{ color: 'black' }}
                                      />
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </th>
                                <th style={{ fontSize: '0.875rem' }}>
                                  Descricao
                                </th>
                                <th
                                  style={{
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  Download
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {dataFiles
                                .filter(arq => arq.Folder !== 'Financeiro')
                                .sort(
                                  (a, b) =>
                                    parseDateString(b.data) -
                                    parseDateString(a.data)
                                )
                                .map(row => {
                                  const isPdf = row.FileName.endsWith('.pdf');
                                  return (
                                    <tr key={row.iFileSystemID}>
                                      <td style={{ fontSize: '0.75rem' }}>
                                        {row.data}
                                      </td>
                                      <td style={{ fontSize: '0.75rem' }}>
                                        {row.FileName}
                                      </td>
                                      <td
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          textAlign: 'center',
                                          fontSize: '0.75rem'
                                        }}
                                      >
                                        <IconButton
                                          size="sm"
                                          alt="Baixar Arquivo"
                                          aria-label="Baixar Arquivo"
                                          onClick={() =>
                                            getUrlFile(row.iFileSystemID)
                                          }
                                          title="Baixar o arquivo" // Tooltip para o botão de download
                                          style={{
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faDownload} />
                                        </IconButton>
                                        {/* <IconButton
                                      size="sm"
                                      alt="Visualizar Arquivo"
                                      aria-label="Visualizar Arquivo"
                                      onClick={() => getShowFIle(row.idarquivo)}
                                      disabled={!isPdf} // Desabilita se não for PDF
                                      title={isPdf ? "Visualizar o arquivo" : "Formato não suportado"}
                                      style={{
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faEye} />
                                    </IconButton> */}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab
                          eventKey="financeiro"
                          title="Financeiro"
                          className="p-3"
                          style={{ fontSize: '0.875rem' }}
                        >
                          <Table size="sm">
                            <thead>
                              <tr>
                                <th style={{ fontSize: '0.875rem' }}>
                                  Data
                                  {isDownloading ? (
                                    <>
                                      <Spinner
                                        size="1rem"
                                        style={{ color: 'black' }}
                                      />
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </th>
                                <th style={{ fontSize: '0.875rem' }}>
                                  Descricao
                                </th>
                                <th
                                  style={{
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  Download
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {dataFiles
                                .filter(arq => arq.Folder === 'Financeiro')
                                .sort(
                                  (a, b) =>
                                    parseDateString(b.data) -
                                    parseDateString(a.data)
                                )
                                .map(row => {
                                  return (
                                    <>
                                      <tr key={row.iFileSystemID}>
                                        <td style={{ fontSize: '0.75rem' }}>
                                          {row.data}
                                        </td>
                                        <td style={{ fontSize: '0.75rem' }}>
                                          {row.FileName}
                                        </td>
                                        <td
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            fontSize: '0.75rem'
                                          }}
                                        >
                                          {' '}
                                          <IconButton
                                            size="sm"
                                            alt="Baixar Arquivo"
                                            aria-label="Baixar Arquivo"
                                            onClick={() =>
                                              getUrlFile(row.iFileSystemID)
                                            }
                                            style={{
                                              marginLeft: 'auto',
                                              marginRight: 'auto'
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              icon={faDownload}
                                            />
                                          </IconButton>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                            </tbody>
                          </Table>
                        </Tab>
                      </Tabs>
                    </>
                  ) : (
                    <>
                      <Flex justifyContent="center">
                        <div className="p-2">
                          <Spinner />
                          <span> Aguarde carregando ...</span>
                        </div>
                      </Flex>
                    </>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => setModalShowArquivo(false)} size="sm">
                    Fechar
                  </Button>
                </Modal.Footer>
                {/* <>
              {preview.fileData && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'white', zIndex: 1000 }}>
                  <button onClick={openInNewTab} style={{ position: 'absolute', top: 10, right: 10 }}>Abrir em Nova Aba</button>
                  <button onClick={() => setPreview({ fileData: null, fileName: '', fileType: '' })} style={{ position: 'absolute', top: 40, right: 10 }}>Fechar</button>
                  <p>Arquivo: {preview.fileName}</p>
                  <p>Tipo: {preview.fileType}</p>
                </div>
              )}
            </> */}
              </Modal>
            </>
          )}
        </AdvanceTableWrapper>
      )}
    </>
  );
};

export default Process;
